/* Patellum - scroll reveal + section motion. Lightweight, no deps.
   Tags .pl-sec/.pl-hero children with reveal classes and flips .in on intersect.
   Respects prefers-reduced-motion (CSS side neutralises transforms). */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  function prep() {
    document.querySelectorAll('.pl-sec .pl-wrap > *:not(.pl-specs):not(.pl-feats):not(.pl-quotes):not(.pl-tiers)').forEach(function (el) {
      el.classList.add('pl-reveal');
    });
    document.querySelectorAll('.pl-specs, .pl-feats, .pl-quotes').forEach(function (el) {
      el.classList.add('pl-stagger');
    });
    document.querySelectorAll('.pl-band .pl-wrap').forEach(function (el) { el.classList.add('pl-stagger'); });
  }

  function observe() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    document.querySelectorAll('.pl-reveal, .pl-stagger, .pl-mech-img').forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { prep(); observe(); });
  } else { prep(); observe(); }
})();
